<template>
  <vx-card :title="chartParams.name" class="md:w-1/3 mr-4 mb-4">
    <!-- CHART -->
    <template slot="no-body">
      <div class="mt-10">
        <apexchart
          type="radialBar"
          height="250"
          :options="chartParams.chartOptions"
          :series="chartParams.series"
        />
      </div>
    </template>

    <!-- DATA -->
    <div
      v-if="chartParams"
      class="flex justify-between text-center mt-4"
      slot="no-body-bottom"
    >
      <div
        class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
      >
        <p class="mt-4">{{ chartParams.chartOptions.labels[0] }}</p>
        <p v-if="isMoney" class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[0]) }} €
        </p>
        <p v-else-if="isPercent" class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[0]) }} %
        </p>
        <p v-else class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[0]) }}
        </p>
      </div>
      <div
        class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
      >
        <p class="mt-4">Total</p>
        <p v-if="isMoney" class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[1]) }} €
        </p>
        <p v-else-if="isPercent" class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[1]) }} %
        </p>
        <p v-else class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.data[1]) }}
        </p>
      </div>
    </div>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "RadialChart",
	props: {
		chartParams: Object,
		isPercent: Boolean,
		isMoney: Boolean
	},
	mixins: [utilsMixin]
};
</script>
